import type { ArtifactPreview } from "~/services/artifacts";
import { ArtifactShell } from "./ArtifactShell";

function imageUrl(content: ArtifactPreview["content"]): string | null {
  if (!content || typeof content !== "object" || Array.isArray(content)) return null;
  const url = (content as Record<string, unknown>).url;
  return typeof url === "string" ? url : null;
}

export const ImageArtifact = ({ preview }: { preview: ArtifactPreview }) => {
  const src = imageUrl(preview.content);

  if (!src) {
    return <div className="my-3 text-sm text-destructive">Unexpected image preview shape.</div>;
  }

  const altText = preview.summary ?? preview.filename ?? preview.artifact_name ?? "Image artifact";

  return (
    <ArtifactShell
      preview={preview}
      expandedContent={
        <img src={src} alt={altText} className="mx-auto max-h-full max-w-full object-contain" />
      }
    >
      <img src={src} alt={altText} className="max-h-96 w-auto object-contain" />
    </ArtifactShell>
  );
};
